import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl(id) {
    let url = `${window.api_url}/shared/cohort_course_completions`;
    if (id) url += `/${id}`;
    return url;
  },

  index(filters) {
    return axios.get(this.baseUrl(), { params: filters }).catch(handleError);
  },

  create(cohortCourseCompletion) {
    return axios.post(this.baseUrl(), cohortCourseCompletion).catch(handleError);
  },

  update(id, data) {
    return axios.patch(this.baseUrl(id), { data }).catch(handleError);
  },

  upsertByIdentifiers(payload) {
    return axios.post(`${this.baseUrl()}/upsert_by_identifiers`, payload).catch(handleError);
  },
};
